import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/employee-profiles',
    name: 'employee',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/employee/index.vue')
  },
  {
    path: '/employee-profiles/create',
    name: 'employee-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/employee/create.vue')
  },
  {
    path: '/employee-profiles/:id/edit',
    name: 'employee-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/employee/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('hr/employee/find', to.params.id)
      next()
    }
  }
]
